import React, { Component } from 'react';
import Fx from './functions/functions';
import CountryList from './functions/CountryList';
import './css/ConsignmentViewer.css';

class ConsignmentViewer extends Component {
  constructor(props) {
    super(props);
  }
  render() {
    var consignment;
    var style = {};
    var service;
    var courier;
      this.props.root.state.utilities.post_services.some(ps => {
        if (this.props.consignment && parseInt(ps.id,10) === parseInt(this.props.consignment.service_id,10)) {
          service = ps;
          return true;
        }
        return false;
      })
      if(typeof service === 'object')
      this.props.root.state.utilities.couriers.some(c => {
        if (c.id === service.courier_id) {
          courier = c;
          return true;
        }
        return false;
      })
    console.log(service);
    console.log(courier);

      if((courier && service && this.props.consignment.tracking_code && this.props.consignment.total_packages)){
          consignment =  (<div>
            <div className="title">Consignment</div>
            <div className="consignment">
              <div className="details">
                <div>{service.name}</div>
                <div>Packages: {this.props.consignment.total_packages}</div>
                <div>Weight: {this.props.consignment.total_weight/1000}kg</div>
              </div>
              <a className="track_btn" target="_blank" href={courier.link.replace('{trackingCode}',this.props.consignment.tracking_code).replace('{postCode}',this.props.address.postcode)}>
                <div className="go_track">Track Parcel</div>
                <div className="tracking_code" >{this.props.consignment.tracking_code}</div>
              </a>
            </div>
          </div>);
      }
          else if((courier && service && this.props.consignment.tracking_code)){
                consignment =  (<div>
                  <div className="title">Consignment</div>
                  <div className="consignment">
                    <div className="details">
                      <div className="bigName">{service.name}</div>
                    </div>
                    <a className="track_btn" target="_blank" href={courier.link.replace('{trackingCode}',this.props.consignment.tracking_code).replace('{postCode}',this.props.address.postcode)}>
                      <div className="go_track">Track Parcel</div>
                      <div className="tracking_code" >{this.props.consignment.tracking_code}</div>
                    </a>
                  </div>
                </div>);
            }
      else if((courier && service)){
          consignment =  (<div>
            <div className="title">Consignment</div>
            <div className="consignment">
              <div className="details">
                  <div>{service.name}</div>
                  <div>Packages: {this.props.consignment.total_packages}</div>
                  <div>Weight: {this.props.consignment.total_weight/1000}kg</div>
              </div>
            </div>
          </div>);
      }
    return (<div className="ConsignmentViewer" style={style} onClick={this.props.onClick}>
        {consignment}
    </div>);
  }
}

export default ConsignmentViewer;



// WEBPACK FOOTER //
// ./src/ConsignmentViewer.js